<ng-template let-view>
  <div *ngIf="view.data" style="height: 100%; flex-grow: 1">
    <ejs-treeview #treeview height="100%" width="100%" id="view.id" [fields]="view.data" [fullRowNavigable]="true"
      expandOn="Click" (nodeSelected)="onComponentCommand($event)">
      <ng-template #nodeTemplate="" let-data="">
        <span>{{ data.nodeText }}</span>
        <span class="e-badge e-badge-primary" *ngIf="data.count">{{
          data.count
          }}</span>
      </ng-template>
    </ejs-treeview>
  </div>
</ng-template>
